module.exports = __webpack_public_path__ + "static/media/teaser-grid-3.19cf9f8d.svg";